import React from "react";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";
import AdminTherapistDetail from "../../components/AdminTherapistDetails/AdminTherapistDetail";


const AdminTherapistDetailPage = () => {
  return (
    <div>
      <UserPage />      
      <AdminTherapistDetail />
      <Footer />
    </div>
  );
};

export default AdminTherapistDetailPage;
